import React from 'react';
import { skillGroups } from '../data';

function Skills() {
  return (
    <section className="section" id="skills">
      <div className="section-head reveal">
        <span className="eyebrow">
          <i className="fa-solid fa-layer-group"></i> Tech stack
        </span>
        <h2 className="section-title">
          Skills &amp; <span className="gradient-text">tools</span>
        </h2>
        <p className="section-sub">The technologies I reach for to build things end to end.</p>
      </div>

      <div className="skill-groups">
        {skillGroups.map((group) => (
          <div key={group.title} className="skill-group card reveal">
            <h3>{group.title}</h3>
            <div className="chips">
              {group.items.map((s) => (
                <span key={s.name} className="chip">
                  <i className={s.icon}></i>
                  {s.name}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
